<template>
  <div>
    <el-card>
      <div class="input-group">
        <div class="group-small">
          <!-- 年份选择 -->
          <div class="rowpart">
            <el-date-picker
              style="width: 200px"
              v-model="year"
              type="year"
              placeholder="选择年"
              value-format="YYYY"
            >
            </el-date-picker>
          </div>

          <!-- 季度选择 -->
          <div class="rowpart">
            <SeasonSelect
              v-model="season"
              @season="this.season = $event"
            ></SeasonSelect>
          </div>
          <!-- 搜搜框 -->
          <div class="rowpart">
            <el-input
              v-model="searchKeyWord"
              placeholder="搜索姓名或单位"
              style="width: 250px; margin-right: 20px"
            ></el-input>
          </div>
        </div>
        <div class="group-small">
          <div class="rowpart">
            <el-button type="primary" @click="exportRes">导出</el-button>
            <el-button
              v-if="bureauManage && !newColumn"
              :disabled="disabled.yearEvaBtn"
              type="primary"
              @click="yearEva"
              >年底考核</el-button
            >
            <el-button
              v-if="bureauManage && newColumn"
              type="primary"
              @click="saveYearEva"
              >保存</el-button
            >
          </div>
        </div>
      </div>
      <!-- 隐表，导出功能专用-->
      <el-table :data="filteredData" style="display: none" id="exportTable">
        <template v-for="column in evaResultTable" :key="column.label">
          <el-table-column
            :prop="column.prop"
            :label="column.label"
            width="180"
            :formatter="formatter"
            sortable
            :fixed="column.fixed"
          >
            <template #default="scope">
              <AnnualEvaRate
                v-if="column.prop == 'annualRate' && scope.row.isOk"
                v-model="scope.row.annualRate"
                @annualRate="scope.row.annualRate = $event"
              ></AnnualEvaRate>
              <span v-else>{{ scope.row[column.prop] }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>

      <!-- 显表 -->
      <el-table
        :data="
          filteredData.slice(
            (currentPage - 1) * pagesize,
            currentPage * pagesize
          )
        "
        style="width: 100%"
        height="600"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        :default-sort="{ prop: 'userId' }"
        row-key="userId"
      >
        <template v-for="column in evaResultTable" :key="column.label">
          <el-table-column
            :prop="column.prop"
            :label="column.label"
            width="180"
            :formatter="formatter"
            sortable
            :fixed="column.fixed"
          >
            <template #default="scope">
              <AnnualEvaRate
                v-if="column.prop == 'annualRate' && scope.row.isOk"
                v-model="scope.row.annualRate"
                @annualRate="scope.row.annualRate = $event"
              ></AnnualEvaRate>
              <span v-else>{{ scope.row[column.prop] }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="180" fixed="right">
          <template #default="scope">
            <el-popconfirm
              title = "确认取消成绩"
              @confirm="doUpdate(scope.$index, scope.row)"
              confirm-button-text="是"
              cancel-button-text="否"
            >
              <template #reference>
                <el-button type="text" @click="handleDetail">取消考核成绩</el-button>
              </template>  
            </el-popconfirm>
            <el-button
              v-if="specialRole"
              @click="handleSpecialEva(scope.$index, scope.row)"
              size="mini"
              type="text"
              >党委评分</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-block">
        <el-pagination
          v-model:current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          v-model:page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="filteredData.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>

      <el-dialog
        v-model="showableComp.specialEvaForm"
        title="党委评分"
        width="40%"
      >
        <el-form>
          <el-row>
            <el-col>
              <el-form-item label="扣分数" label-width="80px">
                <el-input
                  v-model="specialScoreForm.score"
                  placeholder="请输入扣几分"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="备注" label-width="80px">
                <el-input v-model="specialScoreForm.remarks"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="btn-group">
              <el-form-item class="bottom-btn">
                <el-button type="primary" @click="specialScoreSubmit"
                  >确定</el-button
                >
                <el-button @click="doCancel">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form></el-dialog
      >
    </el-card>
  </div>
</template>

<script>
// PersonalTaskMake
import EvaResultDisplayCancel from "../api/EvaResultDisplayCancel";
export default EvaResultDisplayCancel;
</script>

<style scoped lang="scss">
.rowpart {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.input-group {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}

.bottom-btn {
  text-align: end;
}

.pagination-block {
  margin-top: 20px;
}

.group-small {
  display: flex;
}
</style>